import { useEffect } from "react";
import Button from "../Button";
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  StyledModal,
  ANTStyledModal,
} from "./styles";

const Modal = ({
  show = false,
  onHide,
  header,
  size = "lg",
  designPattern = "default",
  children,
  footerActions = [],
  footerActionsNeed = true,
  footerCloseAction,
  footerCloseActionText,
  footerCloseButtonText = "Close",
  footerSubmitButtonText = "Submit",
  hideSubmitButton = false,
  bodyStyle = {},
  handleSubmit,
  handleCancel,
  loading = false,
  mask = true,
  maskClosable = true,
  submitButtonDisabled = true,
  width,
  ...rest
}) => {
  let openModalsCount = 0;
  const handleAfterChange = (state) => {
    if (state === true) {
      openModalsCount++;
      if (!document.body.classList.contains("modal-open")) {
        document.body.classList.add("modal-open");
      }
    } else {
      openModalsCount = Math.max(0, openModalsCount - 1);
      if (openModalsCount === 0) {
        document.body.classList.remove("modal-open");
      }
    }
  };
  return (
    <>
      {designPattern === "default" && (
        // <StyledModal show={show} onHide={onHide} size={size} centered {...rest}>
        //   {header && (
        //     <ModalHeader closeButton closeVariant="white">
        //       <ModalTitle>{header}</ModalTitle>
        //     </ModalHeader>
        //   )}
        //   <ModalBody style={bodyStyle} data-lenis-prevent>
        //     {children}
        //   </ModalBody>
        //   <ModalFooter
        //     className={
        //       !footerActions?.length && !footerCloseAction
        //         ? "modal-unstyled-footer"
        //         : ""
        //     }
        //   >
        //     {footerActions?.map(
        //       ({
        //         text,
        //         key,
        //         onClick,
        //         disabled = false,
        //         isLoading = false,
        //         ...rest
        //       }) => {
        //         return (
        //           <Button
        //             color="primary"
        //             variant="solid"
        //             type="primary"
        //             key={key}
        //             disabled={disabled}
        //             onClick={onClick}
        //             loading={isLoading}
        //             {...rest}
        //           >
        //             {text}
        //           </Button>
        //         );
        //       }
        //     )}
        //     {footerCloseAction && (
        //       <Button onClick={onHide} type="secondary" color="secondary">
        //         {footerCloseActionText}
        //       </Button>
        //     )}
        //   </ModalFooter>
        // </StyledModal>
        <StyledModal
          open={show}
          onCancel={onHide}
          size={size}
          centered
          {...rest}
          title={header}
          mask={mask}
          zIndex="9999999"
          width={
            width
              ? width
              : size === "sm"
              ? "400px"
              : size === "md"
              ? "600px"
              : size === "lg"
              ? "800px"
              : size === "xl"
              ? "1140px"
              : size === "xxl"
              ? "1330px"
              : "900px"
          }
          className={footerActionsNeed ? "" : "ant-custom-action-footer"}
          afterOpenChange={handleAfterChange}
          footer={
            footerActions.length > 0
              ? footerActions.map(
                  ({
                    text,
                    key,
                    onClick,
                    disabled = false,
                    isLoading = false,
                    ...rest
                  }) => (
                    <Button
                      key={key}
                      type="primary"
                      disabled={disabled}
                      loading={isLoading}
                      onClick={onClick}
                      {...rest}
                    >
                      {text}
                    </Button>
                  )
                )
              : footerActionsNeed
              ? [
                  <Button
                    key="back"
                    onClick={handleCancel}
                    disabled={!submitButtonDisabled}
                  >
                    {footerCloseButtonText}
                  </Button>,
                  !hideSubmitButton && (
                    <Button
                      key="submit"
                      type="primary"
                      loading={loading}
                      onClick={handleSubmit}
                      disabled={!submitButtonDisabled}
                    >
                      {footerSubmitButtonText}
                    </Button>
                  ),
                ]
              : null
          }
        >
          {children}
        </StyledModal>
      )}
      {designPattern == "ant" && (
        <ANTStyledModal
          width={width}
          open={show}
          onCancel={onHide}
          title={header}
          size={size}
          mask={mask}
          maskClosable={maskClosable}
          zIndex="9999999"
          className={footerActionsNeed ? "" : "ant-custom-action-footer"}
          afterOpenChange={handleAfterChange}
          centered
          footer={
            footerActions?.length ? (
              footerActions
            ) : footerActionsNeed ? (
              [
                <Button
                  key="back"
                  color="secondary"
                  type="secondary"
                  onClick={handleCancel}
                >
                  {footerCloseButtonText}
                </Button>,
                !hideSubmitButton && (
                  <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={handleSubmit}
                    disabled={!submitButtonDisabled}
                  >
                    {footerSubmitButtonText}
                  </Button>
                ),
              ]
            ) : (
              <></>
            )
          }
          {...rest}
        >
          {children}
        </ANTStyledModal>
      )}
    </>
  );
};

export default Modal;
